module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-accessories-22d1d443bbdc783521851bb0132aca5a.jpg";